import { useContext } from 'react';
import './App.css';
import Footer from './componentes/Footer.jsx';
import Header from './componentes/Header.jsx';
import Lacrosse from './componentes/Lacrosse.jsx';
import Actividades from './paginas/Actividades.jsx';
import Calendario from './paginas/Calendario.jsx';
import Contacto from './paginas/Contacto.jsx';
import Galeria from './paginas/Galeria.jsx';
import Home from './paginas/Home.jsx';
import Serviciosocial from './paginas/Serviciosocial.jsx';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ContextoDonacion } from './contextos/Donacion.js';
import Donaciones from './componentes/Donaciones.jsx';
import Equipo from './paginas/Equipo.jsx';



function App() {
  const { donacion, cambiar } = useContext(ContextoDonacion)

  return (
    <>
      {donacion && <Donaciones cambiar={cambiar} />}
      <BrowserRouter>
        <Header />
        <Routes>

          <Route path='/' element={<Home />} />
          <Route path='/servicio-social' element={<Serviciosocial />} />
          <Route path='/Galeria' element={<Galeria />} />
          <Route path='/Calendario' element={<Calendario />} />
          <Route path='/Lacrosse' element={<Lacrosse />} />
          <Route path='/Actividades' element={<Actividades />} />
          <Route path='/Contacto' element={<Contacto />} />
          <Route path='/Equipo' element={<Equipo />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
